import React, {Component} from 'react';
import {connect} from 'react-redux';

import {getAvailableCategories} from '../../general/selectors';

import {Provider} from './TableWidthContext';
import ForecastTable from './ForecastTable';
import BrowseLayer from './BrowseLayer';
import TableHead from './TableHead';

class Content extends Component {

    constructor(props) {
        super(props);

        this.ref = this.ref.bind(this);
        this.handleWidthChange = this.handleWidthChange.bind(this);

        this.state = {
            node: null,
            width: 1050,
        };
    }

    render() {
        const {node, width} = this.state;
        const {categories} = this.props;
        const show = Boolean(node && categories.length);
        const count = categories.reduce((count, {products}) => count + products.length, 0);
        const className = count < 30 ? 'small-table-content' : null;

        return (
            <Provider value={this.handleWidthChange}>
                <div id="content" className={className} ref={this.ref}>
                    <BrowseLayer width={width - 30} />
                    {show && <ForecastTable parent={node} />}
                    <TableHead />
                </div>
            </Provider>
        );
    }

    ref(node) {
        this.setState({node});
    }

    handleWidthChange(width) {
        this.setState({width});
    }

}

const mapStateToProps = state => {
    const categories = getAvailableCategories(state);

    return {
        categories,
    };
};

export default connect(mapStateToProps)(Content);
